class JoiningProgress {

	constructor(data = {}) {
        // Construct with the provided data or default new JoingProgress
        this.currentStep = data.currentStep ?? null;
        this.stepData = data.stepData ?? [];
        this.user = data.user ?? {
            externalId : null,
            type : null,
            country : null,
            personData : {},
            token : null,
            token_creation : null
        };
        this.basket = data.basket ?? null;
        this.basketParams = data.basketParams ?? [];
        this.basketResume = data.basketResume ?? null;

		this.constInitStep = 0;
		this.constSelectGymStep = 1;
		this.constSelectQuote = 2;
		this.constUserData = 3;
		this.constSummary = 4;
    }

    static async onDataReady(callback) {
        document.addEventListener("initStep", async (event) => {
            callback(event.detail.progress);
        });
    }

    static initStep(progress) {
        document.dispatchEvent(new CustomEvent('initStep', { detail: { progress: progress } }));
    }

    addStep(newStep) {
        const existingStepData = this.stepData.find(data => data.step === newStep.step);
        if (existingStepData) {
            Object.assign(existingStepData, newStep);
        } else {
            this.stepData.push(newStep);
        }
    }

    createStep(stepData) {
        const newStep = {
            step : parseInt(stepData.step),
            name : stepData.name,
            data : stepData.data,
            completed : stepData.completed
        }
        this.addStep(newStep);
    }

    setStepCompleted(stepIndex) {
        const stepData = this.stepData[stepIndex];
        if (stepData) {
            stepData.completed = true;
        }
    }

    updateStepData(stepIndex, data) {
        const stepData = this.stepData[stepIndex];
        if (stepData) {
            stepData.data = data;
        }
    }

    getCompletedSteps() {
        return this.stepData.filter( step => step.completed === true).map( step => { return { stepIndex: step.step, stepName: step.name } });
    }

    getRegisteredSteps() {
        return this.stepData.filter( step => step.data !== null).map( step => { return { stepIndex: step.step, stepName: step.name } });
    }

	setStepDataCountry(new_country) {
		const initStep = this.getInitStep();
		if (initStep) {
			initStep.data.country = new_country.toLowerCase();
		}
	}

	getStepDataCountry() {
		return this.stepData[this.constInitStep]?.data.country;
	}

    setCurrentStep(index) {
        this.currentStep = index;
    }

	getInitStep() {
		return this.stepData[this.constInitStep]
	}
	setInitStepData(data) {
		this.stepData[this.constInitStep].data = data;
	}
	getSelectGymStep() {
		return this.stepData[this.constSelectGymStep]
	}
	getSelectQuoteStep() {
		return this.stepData[this.constSelectQuote]
	}
	getUserDataStep() {
		return this.stepData[this.constUserData]
	}
	getSummaryStep() {
		return this.stepData[this.constSummary]
	}

	getExtendedAttributes() {

		const subscriptionSelection = this.getSelectQuoteStep()?.data;
		let extendedAttributes = [];

		extendedAttributes.push({ attributeId : "WebJNEClub", value : this.getGymId() });
		let originOfLead =  'JOINER-NOT-ENDED-' + this.getUserType().toUpperCase();
		extendedAttributes.push({ attributeId : "WebOriginOfTheLead", value : originOfLead });

		if (!subscriptionSelection) {
			return extendedAttributes;
		}

		if (subscriptionSelection['vg-select-quote']) {
			extendedAttributes.push({  attributeId : "WebJNESub", value : subscriptionSelection['vg-select-quote'][0].globalId });
		}

		if (subscriptionSelection['vg-select-quote--addons']) {
			subscriptionSelection['vg-select-quote--addons'].forEach(addon => {
				if (waterGlobalId.includes(addon.globalId)) {
					extendedAttributes.push({ attributeId : "WebJNEWater", value : "true" });
				}
				if (lockerGlobalId.includes(addon.globalId)) {
					extendedAttributes.push({ attributeId : "WebJNELocker", value : "true" });
				}
			});
		}

		if (subscriptionSelection['vg-select-quote--clipcard']) {
			extendedAttributes.push({ attributeId : "WebJNEOneExp", value : "true" });
		}

		return extendedAttributes;
    }

	setStep0UserData(email, name) {
		this.stepData[0].data.email = email;
		this.stepData[0].data.name = name;
	}

	getStepInitRecieveNewsletter() {
		return this.getInitStep()?.data.newsletter ?? false;
	}

	getStepInitEmail() {
		return this.getInitStep()?.data.email ?? '';
	}

	getStepInitName() {
		return this.getInitStep()?.data.name ?? '';
	}

	getStepInitCountry() {
		return this.getInitStep()?.data.country ?? '';
	}

	setStepResumeIban(iban) {
		this.stepData[this.constSummary].data.iban = iban;
	}

	getStepResumeIban() {
		return this.stepData[this.constSummary]?.data.iban ?? '';
	}

	setStepResumeIbanHolder(ibanHolder) {
		this.stepData[this.constSummary].data.ibanHolder = ibanHolder;
	}

	getStepResumeIbanHolder() {
		return this.stepData[this.constSummary]?.data.ibanHolder ?? '';
	}

    setUser(user) {
        this.user = user;
    }

    setUserExternalId(externalId) {
        this.user.externalId = externalId;
    }

    setUserType(type) {
        this.user.type = this.filterUserType(type);
    }

    filterUserType(rawUserType) {
		let userType = '';
		switch (String(rawUserType).toLowerCase()) {
			case 'active':
				userType = 'Active';
				break;
			case 'inactive':
			case 'temporaryinactive':
			case 'prospect':
				userType = 'Inactive';
				break;
			case 'suspended':
			case 'temporarysuspended':
				userType = 'Suspended';
				break;
			case 'lead':
				userType = 'Lead';
				break;
			case 'blacklist':
				userType = 'Blacklist';
				break;
			case 'new':
				userType = 'New';
				break;
			default:
				userType = 'Guest';
				break;
		}
		return userType;
	}

    setUserCountry(country) {
        this.user.country = country;
    }

    getUserCountry() {
        return this.user.country;
    }

    setUserPersonData(data) {
        this.user.personData = data;
    }

	setUserPersonDataPerson(data) {
        if (!this.user.personData) {
            this.user.personData = {};
        }
        if (!this.user.personData.person) {
            this.user.personData.person = {};
        }

        this.user.personData.person = data;
    }

    setUserToken(token) {
        this.user.token = token;
    }

    setUserTokenCreation(token_creation) {
        this.user.token_creation = token_creation;
    }

    getUser() {
        return this.user;
    }

    getUserType() {
        return this.user.type;
    }

    getUserToken() {
        return this.user.token;
    }

    getUserTokenCreation() {
        return this.user.token_creation;
    }

    getUserExternalId() {
        return this.user.externalId;
    }

    getUSerCurrentGym() {
        return this.user.personData.person?.personId?.center ?? null;
    }

    updateUserPersonDataEmail(email) {
        this.user.personData.personCommunication.email = email;
    }

    resetStepData() {
        this.stepData = [];
    }

    setBasket(basket) {
        this.basket = basket;
    }

    getBasket() {
        return this.basket;
    }

    setBasketParams(params) {
        this.basketParams = params;
    }

    getBasketParams() {
        return this.basketParams;
    }

	getBasketKey() {
		return this.basket?.shoppingBasketKey;
	}

	removeBasketParams(productId) {
		this.basketParams.addOns?.forEach((addOn, index) => {
			if (addOn === productId) {
				this.basketParams.addOns.splice(index, 1);
			}
		});
		this.basketParams.clipCard?.forEach((clipCard, index) => {
			if (clipCard === productId) {
				this.basketParams.clipCard.splice(index, 1);
			}
		});
	}

	removeClipCardStepData() {
		this.stepData.forEach((step, index) => {
			if (step.name === 'step-joining-select-quote') {
				delete step.data['vg-select-quote--clipcard'];
			}
		});
	}

    getBasketResume() {
        return this.basketResume;
    }

    setBasketResume(resume) {
        this.basketResume = resume;
    }

	removeBasketResume() {
		this.basketResume = null;
	}

	getGymId() {
		if (this.stepData[this.constSelectGymStep]) {
			return this.stepData[this.constSelectGymStep].data.id;
		}
		return null;
	}

    getGymCountry() {
        if (this.stepData[this.constSelectGymStep]) {
            return this.stepData[this.constSelectGymStep].data.country;
        }
        return null;
    }

	getGymOpeningDate() {
		if (this.stepData[this.constSelectGymStep]) {
			return this.stepData[this.constSelectGymStep].data.openingDate;
		}
		return null;
	}

	/**
	 * If we set gymOpeningDate as null, we take opening date from progress.
	 *
	 * @param gymOpeningDate null, or string date '2020-05-20'
	 * @returns {boolean} Returns true as default.
	 */
	checkIfGymIsOpen(gymOpeningDate) {
		let diffUntilOpen = 0;
		const today = new Date().getTime();
		if (gymOpeningDate === null) {
			if (this.getGymOpeningDate()) {
				const openGym    = new Date(this.getGymOpeningDate()).getTime();
				diffUntilOpen = openGym - today;
			}
		} else {
			const openGym    = new Date(gymOpeningDate).getTime();
			diffUntilOpen = openGym - today;
		}

		return diffUntilOpen <= 0;
	}

    getGymCity() {
        if (this.stepData[this.constSelectGymStep]) {
            return this.stepData[this.constSelectGymStep].data.city;
        }
        return null;
    }

    getGymName() {
        if (this.stepData[this.constSelectGymStep]) {
            return this.stepData[this.constSelectGymStep].data.name;
        }
        return '';
    }

	getGymDomain() {
		if (this.stepData[this.constSelectGymStep]) {
			if (this.stepData[this.constSelectGymStep].data.country){
				const gymCountry = this.stepData[this.constSelectGymStep].data.country;
				if (gymCountry.toLowerCase() === 'pt') {
					return 'pt-pt';
				} else {
					return 'es-es';
				}
			}
		}

		return VgHelpers.getActualDomain();
	}

    getUserFormData() {
        return getUserDataStep().data;
    }

    async save() {
        // Prepare the data to be sent to the API
        const apiData = {
            data: {
                currentStep: this.currentStep,
                stepData: this.stepData,
                user: this.user,
                basket: this.basket,
                basketParams: this.basketParams,
                basketResume: this.basketResume
            }
        };

        try {
            const api = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
		    api.action = "set_joining_data";
		    api.params = { data: JSON.stringify(apiData) };
            const response = await api.handleRequest();
            //console.log('Saved Hstorage: ', JSON.parse(response));
        } catch (error) {
            console.error("Error saving joining progress:", error);
        }
    }

    async load() {
        try {
            // Attempt to load data from the API
            const api = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
            api.action = "get_joining_data";
            const apiResponse = await api.handleRequest();
            const apiData = JSON.parse(apiResponse);
            //console.log('Loaded Hstorage progress:', apiData);

            if (apiData.data) {
                // Assign the loaded data to the current instance
                this.currentStep = apiData.data.currentStep;
                this.stepData = apiData.data.stepData;
                this.user = apiData.data.user;
                this.basket = apiData.data.basket;
                this.basketParams = apiData.data.basketParams;
                this.basketResume = apiData.data.basketResume;
            } else {
                return null;
            }

        } catch (error) {
            console.error("Error loading joining progress:", error);
            return null;
        }

        return this;
    }
}

export { JoiningProgress };
